/*
 *    Copyright (c) 2018-2025, lengleng All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the pig4cloud.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: lengleng (wangiegie@gmail.com)
 */
import axios from 'axios'; // 引入axios
import QS from 'qs'; // 引入qs模块，用来序列化post类型的数据

import CryptoJS from "crypto-js"
import store from '../store/store';
import router from '../router/index.js';
axios.defaults.baseURL = store.getters.httpUrl;

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          router.replace({
            path: '/Login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          });
          break;

        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          Toast({
            message: '登录过期，请重新登录',
            duration: 1000,
            forbidClick: true
          });
          // 清除token
          localStorage.removeItem('token');
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: '/Login',
              query: {
                redirect: router.currentRoute.fullPath
              }
            });
          }, 1000);
          break;

        // 404请求不存在
        case 404:
          Toast({
            message: '网络请求不存在',
            duration: 1500,
            forbidClick: true
          });
          break;
        // 其他错误，直接抛出错误提示
        default:
          Toast({
            message: error.response.data.message,
            duration: 1500,
            forbidClick: true
          });
      }
      return Promise.reject(error.response);
    }
  })

//随机数
export const randomLenNum = (len, date) => {
  let random = ''
  random = Math.ceil(Math.random() * 100000000000000).toString().substr(0, len || 4)
  if (date) random = random + Date.now();
  return random
}

/**
 *加密处理
 */
export const encryption = (params) => {
  let {
    data,
    type,
    param,
    key
  } = params
  const result = JSON.parse(JSON.stringify(data))
  if (type === 'Base64') {
    param.forEach(ele => {
      result[ele] = btoa(result[ele])
    })
  } else {
    param.forEach(ele => {
      var data = result[ele]
      key = CryptoJS.enc.Latin1.parse(key)
      var iv = key
      // 加密
      var encrypted = CryptoJS.AES.encrypt(
        data,
        key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.ZeroPadding
        })
      result[ele] = encrypted.toString()
    })
  }
  return result
}

export function GET(url) {
  return new Promise((resolve, reject) => {
    axios({
      headers: {
        // 'Authorization': localStorage.getItem('token_type') + localStorage.getItem('access_token')
      },
      method: 'GET',
      url: url,
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err)
      })
  }).catch(function (reason) {
    console.log(reason);
  });
}
//post方法
export function POST(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      headers: {
        // 'Authorization': localStorage.getItem('token_type') + localStorage.getItem('access_token'),
        'Content-Type': 'application/json'
      },
      method: 'post',
      url: url,
      data: params
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err)
      })
  }).catch(function (reason) {
    console.log(reason);
  });
}
//put方法
export function PUT(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      headers: {
        // 'Authorization': localStorage.getItem('token_type') + localStorage.getItem('access_token'),
        'Content-Type': 'application/json'
      },
      method: 'PUT',
      url: url,
      data: params
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err)
      })
  }).catch(function (reason) {
    console.log(reason);
  });
}
//delete方法
export function DELETE(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      headers: {
        // 'Authorization': localStorage.getItem('token_type') + localStorage.getItem('access_token'),
        'Content-Type': 'application/json'
      },
      method: 'DELETE',
      url: url,
      data: params
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err)
      })
  }).catch(function (reason) {
    console.log(reason);
  });
}
//获取城市
export function getCity(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      headers: {
        // 'Authorization': localStorage.getItem('token_type') + localStorage.getItem('access_token')
      },
      method: 'get',
      url: url,
      params: params
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err)
      })
  }).catch(function (reason) {
    console.log(reason);
  });
}
//获取菜单
export function getMenu(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      headers: {
        // 'Authorization': localStorage.getItem('token_type') + localStorage.getItem('access_token')
      },
      method: 'get',
      url: url,
      params: params
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err)
      })
  }).catch(function (reason) {
    console.log(reason);
  });
}

//登录Basic cGlnOnBpZw==
export function login(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      headers: {
        'Authorization': 'Basic dGVzdDp0ZXN0'
      },
      method: 'post',
      url: url,
      params: params
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err)
      })
  }).catch(function (reason) {
    console.log(reason);
  });
}
//获取数据get方法
export function getData(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      headers: {
        // 'Authorization': localStorage.getItem('token_type') + localStorage.getItem('access_token')
      },
      method: 'get',
      url: url,
      params: params
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err)
      })
  }).catch(function (reason) {
    console.log(reason);
  });
}
//搜索
export function search(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      headers: {
        // 'Authorization': localStorage.getItem('token_type') + localStorage.getItem('access_token'),
        'Content-Type': 'application/json'
      },
      method: 'get',
      url: url,
      params: params
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err)
      })
  }).catch(function (reason) {
    console.log(reason);
  });
}



// WEBPACK FOOTER //
// ./src/api/http.js